export const MODALS_KEYS = {
  requestFailed: 'requestFailed',
  paymentFailed: 'paymentFailed',
  packageEdit: 'packageEdit',
  bundleEdit: 'bundleEdit',
  packageUpgrade: 'packageUpgrade',
  productRemovalConfirm: 'productRemovalConfirm',
  registeredAgentRemovalConfirmPrimary: 'registeredAgentRemovalConfirmPrimary',
  registeredAgentRemovalConfirmSecondary:
    'registeredAgentRemovalConfirmSecondary',
  duplicatedMemberConfirm: 'duplicatedMemberConfirm',
};
